import { TypeCampaignEnum } from '@/types';
import type { FlowOperatorMetadata } from '@/types/flow-types';
import { canDeleteTrigger } from '@/components/flows/operators/registry';

export interface RegisterOnSiteData {
  event: string;
}

export function createDefaultData(): RegisterOnSiteData {
  return {
    event: 'register_on_site',
  };
}

const RegisterOnSite: FlowOperatorMetadata<RegisterOnSiteData> = {
  id: 'boxregisteronsite',
  kind: 'trigger',
  label: 'flows.operators.registerOnSite.label',
  icon: 'fa-user-plus',
  hasConfiguration: false,
  availableIn: [],
  hidden: true,

  incompatibilities: {
    [TypeCampaignEnum.AUTOMATION]: {
      nextOperators: [
        'boxabandonpanier', 'boxperiodiclaunching', 'boxscrollpage',
        'boxstatuscommand', 'boxregisteronsite', 'boxsubscribetonewsletter',
        'boxtag', 'boxlist', 'boxfiltre_2',
        'boxfiltre_4', 'openemail', 'clicklink',
        'boxtriggerinternalevent',
      ],
    },
  },

  defaultData: createDefaultData,

  outputs: () => 1,

  canBeDeleted(operatorId: string, flow: any): Promise<boolean | string> {
    return canDeleteTrigger(flow, operatorId);
  },
};

export default RegisterOnSite;
